import SearchInput from './input';

export default SearchInput;
